import { memo } from "react";
import { Button } from "@heroui/button";
import { Pagination } from "@heroui/react";

interface BottomContentProps {
  selectedKeys: any;
  page: number;
  pages: number;
  setPage: (page: number) => void;
  filteredItems: any[];
  onNextPage: () => void;
  onPreviousPage: () => void;
}

const BottomContent: React.FC<BottomContentProps> = ({
  selectedKeys,
  setPage,
  page,
  pages,
  filteredItems,
  onNextPage,
  onPreviousPage,
}) => {
  // const debouncedSetPage = useCallback(
  //   debounce((newPage) => {
  //     setPage(newPage);
  //   }, 300),
  //   [],
  // );
  // const handlePageChange = (newPage: number) => {
  //   debouncedSetPage(newPage);
  // };

  return (
    <div className="relative px-2 flex justify-between items-center -z-0">
      <span className="w-[30%] text-small text-default-400">
        {selectedKeys === "all"
          ? "All items selected"
          : `${selectedKeys.size} of ${filteredItems.length} selected`}
      </span>
      <Pagination
        isCompact
        showControls
        showShadow
        classNames={{
          cursor: "bg-[#008c8fff]",
        }}
        className={"lg:flex md:visible]"}
        page={page}
        total={pages}
        onChange={setPage}
      />
      <div className=" w-[30%] justify-end gap-2 hidden lg:visible ">
        <Button
          isDisabled={pages === 1}
          size="sm"
          variant="flat"
          className={"bg-[#008c8fff]"}
          onPress={onPreviousPage}
        >
          Previous
        </Button>
        <Button
          isDisabled={pages === 1}
          size="sm"
          variant="flat"
          className={"bg-[#008c8fff]"}
          onPress={onNextPage}
        >
          Next
        </Button>
      </div>
    </div>
  );
};

export default memo(BottomContent);
